import {
  Transforms
} from 'slate';

import * as serializer from 'basic-editor-value-serializer';

function withDocumentStructure(editor) {

  const { normalizeNode } = editor;

  editor.normalizeNode = function _normalizeNode([node, path]) {

    if (path.length === 1) {

      if (serializer.allTypes.topLevelElements.includes(node.type) === false) {
        Transforms.removeNodes(editor, { at: path });
        return;
      }

    }

    normalizeNode([node, path]);

  };

  return editor;
};

export default withDocumentStructure;